import { HttpClient } from '@angular/common/http';
import { isDevMode } from '@angular/core';
import { appSettings } from './app-settings';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var AppSettingsService = /** @class */ (function () {
    function AppSettingsService(http) {
        this.http = http;
        this.configUrl = 'config/';
    }
    AppSettingsService.prototype.getSettings = function () {
        return this.http.get(this.configUrl)
            .toPromise()
            .then(function (settings) {
            if (isDevMode()) {
                console.log("Settings from API: ", settings);
            }
            Object.assign(appSettings, settings);
        });
    };
    AppSettingsService.ngInjectableDef = i0.defineInjectable({ factory: function AppSettingsService_Factory() { return new AppSettingsService(i0.inject(i1.HttpClient)); }, token: AppSettingsService, providedIn: "root" });
    return AppSettingsService;
}());
export { AppSettingsService };
